export enum TermsOfBusinessStatus {
	NotSent = 1,
	Sent = 2,
	Signed = 3,
}
